import React, { createContext, useContext, useState } from 'react';
import Cookies from 'js-cookie';
import TokenService from '../../services/token.service';
// CryptoJS is no longer imported here — decryption is centralised in TokenService

const PermissionsContext = createContext({
    permissions: [],
    setPermissions: () => {},
});

export const usePermissions = () => useContext(PermissionsContext);

export const PermissionsProvider = ({ children }) => {
    const cookieData = Cookies.get('permissions');
    // Use the single shared decryptData from TokenService — no duplicated key/logic
    const initialPermissions = cookieData ? (TokenService.decryptData(cookieData) ?? []) : [];
    const [permissions, setPermissions] = useState(initialPermissions);

    return (
        <PermissionsContext.Provider value={{ permissions, setPermissions }}>
            {children}
        </PermissionsContext.Provider>
    );
};